<script setup>
import { getGrouplist } from '@/api/UserGroup';
import { ref, onMounted, onUnmounted } from 'vue';
import { DEV_MODE } from '@/config/dev-mode';

// 모바일 감지
const isMobile = ref(false);
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};
onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});

const props = defineProps({
  prSelectedGroup: Object,
});

const isDialogVisibleChange = ref(true);
const emit = defineEmits();

const isExpanded = ref(false);
const shouldShowExpandButton = ref(false);
const groupSetList = ref(null);

const close = () => {
  emit('close');
  DEV_MODE && console.log('close가 호출됨');
};
const listData = ref({});
const getGroupList = async () => {
  try {
    const params = {};
    const data = await getGrouplist(params); // 그룹리스트 조회
    listData.value = data;
  } catch (error) {
    console.error('Failed to load users:', error);
  }
};
onMounted(async () => {
  await getGroupList();
  nextTick(() => {
    checkScroll();
  });
});
const change = (selectItem) => {
  const selectedGroup = selectItem.userGroupId;
  const filteredData = listData.value.filter((item) => item.userGroupId === selectedGroup);
  emit('change', filteredData);
};
const openSetting = () => {
  emit('openSetting', 'type1');
};

const checkScroll = () => {
  if (groupSetList.value) {
    const fixedHeight = 258;
    const hasScroll = groupSetList.value.scrollHeight > fixedHeight;
    shouldShowExpandButton.value = hasScroll;
    DEV_MODE && console.log('높이:', hasScroll);
  }
};

const expandList = () => {
  isExpanded.value = true;
  DEV_MODE && console.log('버튼 눌림', isExpanded.value);
};
</script>
<template>
  <VDialog
    v-model="isDialogVisibleChange"
    class="v-dialog-sm dialog-st1 custom-dialog"
    :class="[{ expanded: isExpanded }, isMobile ? 'pop-group-mobile' : '']"
    v-bind="
      isMobile ? { width: '100%', maxWidth: '100%', fullscreen: true } : { minWidth: '600px' }
    "
    :hide-overlay="!isMobile"
  >
    <VCard :class="isMobile ? '' : 'br16'">
      <!-- <DialogCloseBtn
        variant="text"
        size="default"
        @click="close"
      /> -->
      <!-- <button class="dial-close" @click="close"></button> -->
      <div class="saju-pop-inner1" :class="{ expanded: isExpanded }">
        <div class="pop-tit-box1" style="margin-bottom: 16px">
          <button @click="openGroupAdd(0)" class="btn-group-setting">
            <i class="icon-setting xs" />그룹관리
          </button>
          <div class="title-text">그룹 선택</div>
          <!-- <div
            class="close-button"
            @click="close()"
          >
            Close
          </div> -->
          <button class="dial-close" @click="close"></button>
        </div>
        <div class="saju-pop-body1" :class="{ expanded: isExpanded }">
          <div class="pop-search-box1" :class="{ expanded: isExpanded }">
            <div class="pop-group-list scroll" :class="{ expanded: isExpanded }" ref="groupSetList">
              <div
                v-for="(item, index) in listData"
                :key="index"
                class="group-item"
                :class="{ active: prSelectedGroup?.userGroup?.userGroupId === item.userGroupId }"
                @click="change(item)"
              >
                {{ item.name }} ({{ item.memberCount }})
              </div>
            </div>
          </div>
          <button
            v-if="shouldShowExpandButton && !isExpanded"
            @click.stop="expandList"
            class="expand-btn"
          >
            펼쳐보기 +
          </button>
          <div class="notice-group">
            <span class="warn-text"
              >*변경할 그룹을 선택해주세요. 선택된 그룹으로 바로 적용되므로 유의해주세요.</span
            >
          </div>
        </div>
      </div>
    </VCard>
  </VDialog>
</template>

<style lang="scss">
// 모바일 fullscreen 오버라이드
.pop-group-mobile.v-dialog--fullscreen {
  .v-overlay__content {
    width: 100% !important;
    height: 100dvh !important;
    max-height: 100dvh !important;
  }

  .v-card {
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    border-radius: 0 !important;
  }

  .saju-pop-inner1 {
    width: 100% !important;
    min-height: 0 !important;
    height: 100% !important;
    padding: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    gap: 0 !important;
  }

  .pop-tit-box1 {
    flex-shrink: 0;
    padding: 12px 16px !important;
    padding-top: calc(12px + var(--safe-area-top, 0px));
    min-height: calc(48px + var(--safe-area-top, 0px));
    display: flex !important;
    align-items: center !important;

    .btn-group-setting {
      order: -1;
    }

    .title-text {
      width: auto !important;
      flex: 1;
      margin-left: 0 !important;
      text-align: center !important;
    }
  }

  .saju-pop-body1 {
    flex: 1 !important;
    height: auto !important;
    min-height: 0 !important;
    overflow-y: auto !important;
    padding: 16px !important;
    gap: 12px !important;

    &.expanded {
      height: auto !important;
    }
  }

  .pop-search-box1 {
    width: 100% !important;
    min-height: 0 !important;
    height: auto !important;

    &.expanded {
      height: auto !important;
    }
  }

  .pop-group-list {
    width: 100% !important;
    height: auto !important;
    max-height: none !important;
    overflow-y: visible !important;

    &.expanded {
      height: auto !important;
    }
  }

  .expand-btn {
    position: static !important;
    margin: 0 auto;
  }

  .notice-group {
    width: 100% !important;
  }
}
</style>
